import { PaidRooms } from "@/shared/server/apis/types";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const paymentRoomAtom = atom<PaidRooms[]>({
    default: [],
    key: ATOM_KEY.SELECTED_PAYMENT_ROOM,
});

export const usePaymentRoomState = () => useRecoilState(paymentRoomAtom);
export const useSetPaymentRoomState = () => useSetRecoilState(paymentRoomAtom);
export const usePaymentRoomValue = () => useRecoilValue(paymentRoomAtom);

const isDeletePaidRooms = atom({
    default: false,
    key: ATOM_KEY.SELECTED_PAID_ROOM,
});

export const useSetIsPaidRoom = () => useSetRecoilState(isDeletePaidRooms);
export const usePaidRoomIsValue = () => useRecoilValue(isDeletePaidRooms);
